"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const MenuList_1 = __importDefault(require("@mui/material/MenuList"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Popper_1 = __importDefault(require("@mui/material/Popper"));
const ExpandMoreRounded_1 = __importDefault(require("@mui/icons-material/ExpandMoreRounded"));
const useStyles = (0, mui_1.makeStyles)()((theme) => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    iconButton: {
        padding: 0,
    },
    icon: {
        fontSize: 23,
    },
    popper: {
        zIndex: theme.zIndex.modal,
    },
    menuList: {
        padding: theme.spacing(0.5),
    },
    menuItem: {
        fontSize: 14,
        minHeight: 28,
    },
}));
const STATIC_CHECK_LABELS = ['QueuePmt'];
const CheckOptionPicker = ({ optionLabels = STATIC_CHECK_LABELS, onSelect, className, icon, disabled = false, }) => {
    const { classes, cx } = useStyles();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [open, setOpen] = (0, react_1.useState)(false);
    const closeTimerRef = (0, react_1.useRef)(null);
    const clearCloseTimer = (0, react_1.useCallback)(() => {
        if (closeTimerRef.current) {
            window.clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
    }, []);
    const handleOpen = (0, react_1.useCallback)((event) => {
        if (disabled)
            return;
        clearCloseTimer();
        setAnchorEl(event.currentTarget);
        setOpen(true);
    }, [clearCloseTimer, disabled]);
    const handleToggle = (0, react_1.useCallback)((event) => {
        if (disabled)
            return;
        clearCloseTimer();
        setAnchorEl(event.currentTarget);
        setOpen((prev) => !prev);
    }, [clearCloseTimer, disabled]);
    const scheduleClose = (0, react_1.useCallback)(() => {
        clearCloseTimer();
        closeTimerRef.current = window.setTimeout(() => {
            setOpen(false);
        }, 120);
    }, [clearCloseTimer]);
    const handleSelect = (0, react_1.useCallback)((selectedLabel) => {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedLabel);
        setOpen(false);
    }, [onSelect]);
    (0, react_1.useEffect)(() => () => clearCloseTimer(), [clearCloseTimer]);
    return (<span className={cx(classes.root, className)}>
      <IconButton_1.default size="small" className={classes.iconButton} onMouseEnter={handleOpen} onMouseLeave={scheduleClose} onClick={handleToggle} onMouseDown={(event) => event.preventDefault()} aria-label="Check options" aria-haspopup="menu" disabled={disabled}>
        {icon || <ExpandMoreRounded_1.default className={classes.icon}/>}
      </IconButton_1.default>
      <Popper_1.default open={open} anchorEl={anchorEl} placement="bottom-end" className={classes.popper}>
        <ClickAwayListener_1.default onClickAway={() => setOpen(false)}>
          <Paper_1.default onMouseEnter={clearCloseTimer} onMouseLeave={scheduleClose}>
            <MenuList_1.default className={classes.menuList}>
              {optionLabels.map((optionLabel) => (<MenuItem_1.default key={optionLabel} className={classes.menuItem} onClick={() => handleSelect(optionLabel)}>
                  {optionLabel}
                </MenuItem_1.default>))}
            </MenuList_1.default>
          </Paper_1.default>
        </ClickAwayListener_1.default>
      </Popper_1.default>
    </span>);
};
exports.default = CheckOptionPicker;
